/* globals elkitorg_config */

import CartUtil from 'common/util/CartUtil';
import CurrencyUtil from "common/util/CurrencyUtil";
import ModalUtil from "common/util/ModalUtil";

class CartItem {
	static select = $context => $context.select('.cart-item');

	constructor($item) {
		this.$item = $item;
		this.quantityAvailable = $item.attr('data-max-quantity');
		this.productID = $item.attr('data-product-id');
		this.bindEvents();
	}

	bindEvents() {
		const self = this;

		self.$item.on('change', '.quantity', function (e, args) {
			e.stopPropagation();
			const quantity = args.val;

			CartUtil.updateItem(self.getId(), quantity).then(function (response) {
				if (response.data.error) {
					return;
				}

				self.setQuantityValue(quantity);
				self.setPriceInfoVisibility(quantity);
				self.setTotal(response.data.item_total, quantity);

				if (self.quantityAvailable) {
					self.$item.toggleClass('cart-item_exceed', (self.quantityAvailable < quantity));
				}

			});
		});

		self.$item.on('click', '.cart-item__btn-delete', function () {
			const itemId = self.getId();
			if (window.delete_item_modal !== undefined) {
				const $deleteModal = $(window.delete_item_modal);

				$deleteModal.find('.cart-item-delete-modal__btn').data('id', itemId)
				ModalUtil.openContent($deleteModal);
			} else {
				CartUtil.deleteItem(itemId).then(function () {
					self.$item.trigger('delete_cart_item');
				});
			}
		});

		self.$item.on('click', '.cart-item__accessories-btn', function () {
			ModalUtil.openAjax(`${elkitorg_config.elkihelper_accessories_modal_url}?product_id=${self.productID}&limit=30`);
		});

	}

	setQuantityValue(value) {
		this.$item.find('.quantity').each(function () {
			$(this).trigger('update:cart-item', {val: value})
		})
	}

	getId() {
		return this.$item.data('item_id');
	}

	setTotal(total, quantity) {
		const $totalBlock = this.$item.find('.cart-item__price');
		const comparePrice = $totalBlock.data('compare');
		if (comparePrice) {
			$totalBlock.find('.cart-item__price-new').html(total);
			const currency_info = elkitorg_config.currency_info[elkitorg_config.currency];
			$totalBlock.find('.cart-item__price-former').html(CurrencyUtil.format(comparePrice * quantity, currency_info, false));
		} else {
			$totalBlock.find('.cart-item__price-current').html(total);
		}

	}

	setPriceInfoVisibility(quantity) {
		const $priceInfo = this.$item.find('.cart-item__per-one');
		if (quantity > 1) {
			$priceInfo.show();
		} else {
			$priceInfo.hide();
		}
	}

}

export default () => Component(CartItem.select, $item => new CartItem($item));
